import React from "react";
import { Box, Chip, Tooltip, Typography } from "@mui/material";
const { smsStatusChipLabel } = require("./smsProviderDisplay");

/**
 * SMS delivery status for admin Communications tables (ClickSend Failed shows reason).
 */
export function SmsStatusDisplay({ status, statusDetail }) {
  const label = smsStatusChipLabel(status);
  const isDelivered = label === "Delivered";
  const isFailed = label === "Failed";
  const detail =
    isFailed && statusDetail ? String(statusDetail).trim() : "";

  const chip = (
    <Chip
      size="small"
      label={label}
      color={isDelivered ? "success" : isFailed ? "error" : "default"}
      variant={isDelivered ? "filled" : "outlined"}
    />
  );

  if (!detail) {
    return chip;
  }

  return (
    <Tooltip title={detail} arrow placement="top">
      <Box
        sx={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: 0.25,
          maxWidth: 160,
        }}
      >
        {chip}
        <Typography
          variant="caption"
          color="error.main"
          sx={{ lineHeight: 1.2, wordBreak: "break-word" }}
        >
          {detail}
        </Typography>
      </Box>
    </Tooltip>
  );
}
